"use strict";

import { storesData, initStoresMap, fetchStoresData, maybeLoadMap } from './stores_map.js';

$(function() {
    const $scrollableEl = $(window);

    $('.show-on-map').click(function(e) {
        e.preventDefault();
        const storeSlug = $(this).closest('.store').attr('id');
        if (storesData == null) {
            // Unbind the "scroll" event handler
            $scrollableEl.off('scroll', maybeLoadMap);
            fetchStoresData({
                initStoresMapOptions: {
                    storeSlug: storeSlug,
                    scrollIntoView: true,
                },
            });
        } else {
            initStoresMap({
                storeSlug: storeSlug,
                scrollIntoView: true,
            });
        }
    });

    if (navigator.userAgent.indexOf('Opera Mini') > -1) {
        // For Opera Mini, which does not support the "scroll" event, load the
        // map
        fetchStoresData();
    } else {
        $scrollableEl.on('scroll', null, {
            $scrollableEl: $scrollableEl,
        }, maybeLoadMap);
    }
});
